import script from "./TokenExpierdModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenExpierdModal.vue?vue&type=script&setup=true&lang=js"

import "./TokenExpierdModal.vue?vue&type=style&index=0&id=c54f2c3c&scoped=true&lang=css"
script.__scopeId = "data-v-c54f2c3c"

export default script